
    <div *ngIf="treeNode" class="tree-node">
        <a [routerLink]="[routerLinkBase, treeNode.id]">{{displayText}}:&nbsp;{{treeNode.summary | truncate : 80}}&nbsp;&nbsp;
            <i class="fa" [ngClass]="{'fa-pencil': !treeNode.archivedAt, 'fa-check': !!treeNode.archivedAt}"></i>
        </a>
        <div *ngIf="treeNode.childForms && treeNode.childForms.length" class="children-container">
            <child-forms-tree [childForms]="treeNode.childForms"></child-forms-tree>
        </div>
    </div>
  